var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.26812 0 0 6.26801 0 14C0 21.732 6.26812 28 14 28C21.7319 28 28 21.732 28 14C28 6.26801 21.7319 0 14 0ZM18.8388 14.7421L11.8387 19.1171C11.6971 19.2055 11.5361 19.25 11.375 19.25C11.2291 19.25 11.083 19.2137 10.9507 19.1402C10.6726 18.986 10.5 18.6933 10.5 18.375V9.625C10.5 9.30672 10.6726 9.01403 10.9507 8.85981C11.2289 8.70472 11.569 8.71412 11.8387 8.88289L18.8388 13.2579C19.0945 13.4181 19.25 13.6984 19.25 14C19.25 14.3016 19.0945 14.5819 18.8388 14.7421Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
export default __webpack_public_path__ + "static/media/icon-play.4a5a38981615c40889351e3077336983.svg";
export { ForwardRef as ReactComponent };